import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

const HOUSE_ADS = [
  {
    label: "Sponsored",
    headline: "Find Nepali businesses near you",
    cta: "Browse Directory",
    to: "/app/company",
    external: false,
  },
  {
    label: "Sponsored",
    headline: "Discover upcoming community events",
    cta: "See Events",
    to: "/app/events",
    external: false,
  },
  {
    label: "Advertise with us",
    headline: "Reach the Nepali community",
    cta: "Contact Us",
    to: "mailto:ads@sajhasocial.com",
    external: true,
  },
];

export function interleaveAds<T>(items: T[], every = 10): (T | { __adIndex: number })[] {
  const result: (T | { __adIndex: number })[] = [];
  items.forEach((item, i) => {
    result.push(item);
    if ((i + 1) % every === 0) {
      result.push({ __adIndex: Math.floor((i + 1) / every) - 1 });
    }
  });
  return result;
}

export function isAdSlot(item: unknown): item is { __adIndex: number } {
  return typeof item === "object" && item !== null && "__adIndex" in item;
}

interface AdSlotProps {
  index?: number;
  variant?: "post" | "banner";
}

export default function AdSlot({ index = 0 }: AdSlotProps) {
  const ad = HOUSE_ADS[index % HOUSE_ADS.length];

  return (
    <Card
      variant="outlined"
      sx={{
        mb: 2,
        borderStyle: "dashed",
        borderColor: "grey.300",
        bgcolor: "grey.50",
      }}
    >
      <CardContent sx={{ py: 1.5, "&:last-child": { pb: 1.5 } }}>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
          {ad.label}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography variant="body2" color="text.secondary">
            {ad.headline}
          </Typography>
          {ad.external ? (
            <Button
              size="small"
              variant="outlined"
              href={ad.to}
              component="a"
              sx={{ ml: 1, whiteSpace: "nowrap", fontSize: "0.7rem" }}
            >
              {ad.cta}
            </Button>
          ) : (
            <Button
              size="small"
              variant="outlined"
              component={Link}
              to={ad.to}
              sx={{ ml: 1, whiteSpace: "nowrap", fontSize: "0.7rem" }}
            >
              {ad.cta}
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
